import { jQuery } from './utils/jquery.js';
import { Fancybox } from "@fancyapps/ui";

jQuery(function ($) {
    var productInstance = {
        successPopUpID: '#popup-success-default',
        successPopUpEl: $('#popup-success-default'),
        preloader_on: function () {
            $('body').addClass('processing').block({
                message: "Please wait..", overlayCSS: {
                    background: '#fff', opacity: 0.6
                }
            });
        }, preloader_off: function () {
            $('body').removeClass('processing').unblock();
        },
        is_simple_product: function () {
            if ($(document).find('.product-type-simple').length) {
                return true;
            } else {
                return false;
            }
        },
        is_variable_product: function () {
            if ($(document).find('.product-type-variable').length) {
                return true;
            } else {
                return false;
            }
        },
        validate_add_to_cart: function (productData) {
            // check product data
            if (typeof productData === "undefined" || productData === null || Object.keys(productData).length === 0) {
                alert("Product data is required.");
                return false;
            }
            // check product ID
            if (typeof productData.product_id === 'undefined' || (!productData.product_id)) {
                alert("Product id is required.");
                return false;
            }
            // if product is variable product
            if (this.is_variable_product()) {
                if (typeof productData.variation_id === 'undefined' || (!productData.variation_id) || productData.variation_id === 0) {
                    alert("Please select some product options before adding this product to your cart.");
                    return false;
                }
            }

            return true;
        },
        add_to_cart: function (productData, thisButton) {

            if (!this.validate_add_to_cart(productData) || !$(document).triggerHandler('validate_add_to_cart')) {
                // got errors
                return;
            }
            // set default quantity
            if (typeof productData.product_qty === 'undefined' || (!productData.product_qty)) {
                productData.product_qty = 1;
            }

            let data = {
                action: 'woocommerce_wagt_ajax_add_to_cart',
                product_id: productData.product_id,
                product_sku: '',
                quantity: productData.product_qty,
                variation_id: productData.variation_id,
                meta_data: productData.meta_data,
                meta_data_gift: productData.meta_data_gift
            };

            if ($('.product-carte').length > 0) {
                let defaultGiftData = {
                    pw_gift_card_recipient_name: $('[name="happy_recipient"]').val(),
                    pw_gift_card_from: $('[name="generous_donor"]').val(),
                    pw_gift_card_email_design_id: 0
                }

                data = $.extend(data, defaultGiftData);
            }

            if ($('[data-value="Autre montant"]').hasClass('is-active')) {
                let customGiftData = {
                    'attribute_gift-card-amount': 'Montant personnalisé',
                    pw_gift_cards_custom_amount: parseInt($('[name="custom_amount"]').val()),
                };
                data = $.extend(data, customGiftData);
            }

            $(document.body).trigger('adding_to_cart', [thisButton, data]);

            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    productInstance.preloader_on();
                    thisButton.removeClass('added').addClass('loading');
                },
                complete: function (response) {
                    thisButton.addClass('added').removeClass('loading');
                },
                success: function (response) {
                    productInstance.preloader_off();

                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return true;
                    } else {
                        $(document.body).trigger('wagt_custom_added_to_cart', [response.fragments, response.cart_hash, thisButton, response]);
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, thisButton]);
                    }
                },
            });
            return false;
        }
    }

    // restrict add to cart button
    // single_add_to_cart_button: WooCommerce add to cart button
    // js-custom-variation-add-to-cart-button: add to cart button for variable products

    $(document).on('click', 
        '.single_add_to_cart_button, .js-custom-variation-add-to-cart-button', 
        function (e) {
        e.preventDefault();
        var $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_qty = $form.find('input[name=quantity]').val() || 1,
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0;

        var item_meta = [];

        $('.product-options__option-wrapper').each(function(index) {
            var color = $(this).find('.js-selected-attribute-name').text();
            var quantity = $(this).find('input[type="number"]').val();
            
            if (quantity == 0) {
                return;
            }
            // Créez un objet JSON pour les données de cet élément
            var itemData = {
                'value': color,
                'quantity': parseInt(quantity) // Assurez-vous de convertir la quantité en nombre
            };

            // Utilisez l'index comme clé unique
            var uniqueKey = 'item_' + index;

            // Ajoutez l'objet itemData à l'objet dataObj sous une clé unique
            item_meta.push(itemData);
        });

        var item_meta_gift = [];
        if($('.product-carte').length > 0 ) {
            if ($('.js-carte-comment-radio[value="postcard"]').is(':checked')) {
                item_meta_gift.push({
                    type: 'postcard',
                    name: $('.js-comment-postcard-input--name').val(),
                    address: $('.js-comment-postcard-input--address').val(),
                    message: $('.js-comment-postcard-input--message').val(),
                });
            }

            if ($('.js-carte-comment-radio[value="takeaway"]').is(':checked')) {
                item_meta_gift.push({
                    type: 'takeaway'
                });
            }

            if ($('.js-carte-comment-radio[value="mail"]').is(':checked')) {
                item_meta_gift.push({
                    type: 'mail',
                    email: $('.js-comment-email-input').val()
                });
            }
        }

        let productData = {
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
            meta_data: item_meta,
            meta_data_gift: item_meta_gift
        };

        // process add to cart
        productInstance.add_to_cart(productData, $thisbutton);
    });
    // on product added to cart
    $(document).on('wagt_custom_added_to_cart', function (event, fragments, cart_hash, thisButton, response) {
        // Show HTML element
        // change image in popup
        if (typeof response.product_image != "undefined" && response.product_image) {
            productInstance.successPopUpEl.find('.popup-success__image').attr('src', response.product_image);
        } else {
            productInstance.successPopUpEl.find('.popup-success__image').attr('src', productInstance.successPopUpEl.data('placeholder-url'));
        }

        // Fancybox.show([{src: productInstance.successPopUpID, type: "inline"}]);
    });

    /*
    Popup reserve form
    */
    $(document).on("submit", ".js-popup-reserve-form", (e) => {
        e.preventDefault();

        const form = $(e.target);
        let data = $(form).serialize();
        data += "&action=wagt_reserve_product";
        let submit_btn = $(form).find('button[type="submit"]');
        let submit_btn_text = $(submit_btn).html();
        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $(submit_btn).html("<span>Please wait...</span>").attr('disabled', true);
                $(form).find(".input__wrapper").each(function () {
                    $(this).find(".error_msg").remove();
                });
            },
            complete: function (response) {
                $(submit_btn).html(submit_btn_text).attr('disabled', false);
            },
            success: function (response) {
                if (response.succ) {
                    // $(".js-reserve-product-btn").hide();
                    $('body').addClass('is_reserved_product');
                    $('[data-fancybox="reserve"]').hide();

                    form[0].reset();
                    form.parents(".popup").find("[data-fancybox-close]")[0].click();
                    if (response.is_appointment) {
                        console.log('appointment')
                        Fancybox.show([{ src: '#popup-appointment', type: "inline", click: null, dragToClose: false }]);
                        // form.parents(".popup").find(".js-popup-success-default")[0].click();
                    } else {
                        form.parents(".popup").find(".js-popup-success-reserve")[0].click();
                    }

                } else {
                    $(form).find('.popup-reserve__button').parents(".input__wrapper").append("<p class='error_msg'>" + response.msg + "</p>");
                    if (typeof response.errors != 'undefined') {
                        $.each(response.errors, function (key, value) {
                            $(form).find('[name="' + key + '"]').parents(".input__wrapper").append("<span class='error_msg'>" + value + "</span>");
                        });
                    }
                }
            },
        });
    });

    Fancybox.bind('[data-fancybox="reserve"]', {
        click: null,
        dragToClose: false,
    });

    // Alert artist
    if ($('.artist-alert-wrapper').length) {

        let checkData = {
            action: 'sf_artists_is_register',
            entity_id: $('[name="entity_id"]').val(),
            email: $('.artist-alert-wrapper').data('user-email')
        };

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: checkData,
            success: function (response) {
                if(!response) {
                    allowAlert();
                }
            },
        });

        function allowAlert() {
            $('.artist-alert-wrapper').show();

            $('.js-artist-alert-btn').on('click', function(e) {
                e.preventDefault();
                $('.artist-alert-form-wrapper').toggle();
                $('.js-artist-alert-btn').hide();
            })

            $('.artist-alert-form').on('submit', function(e) {
                e.preventDefault();
                const form = $(e.target);
                let data = $(form).serialize();
                data += "&action=sf_artists_register";

                $.ajax({
                    type: 'post',
                    url: wc_add_to_cart_params.ajax_url,
                    data: data,
                    success: function (response) {
                        $('.artist-message-success').show();
                        $('.artist-alert-form-wrapper').hide();
                        $('.js-artist-alert-btn').hide();
                        $('.artist-alert-legend').hide();
                    },
                });
            });
        }
    }
});
